import { Segmented } from 'antd';
import React, { useState } from 'react';
import ListALLTC from './ListALLTC';
import TandC from './TandC';

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const ManageTC = () => {
  const perm = getPermission('/manage-letter-formats');
  const [selectedTab, setSelectedTab] = useState("All T&C");
  const [editData, setEditData] = useState(null);

  const handleSegChange = (value) => {
    setSelectedTab(value);
    if (value === "Add New T&C") setEditData(null);
  };

  const handleEdit = (record) => {
    setEditData(record);
    setSelectedTab("Add New T&C");
  };

  const handleHomeSeg = async () => {
    setSelectedTab("All T&C");
  };

  return (
    <div>
      <Segmented
        size="large"
        block
 options={[
          "All T&C",
          {
            label: selectedTab === "Add New T&C" && editData ? "Edit T&C" : "Add New T&C",
            value: selectedTab === "Add New T&C" && editData ? "Edit T&C" : "Add New T&C",
            disabled: !perm.add && !perm.edit,
          },
        ]}
        value={selectedTab}
        onChange={handleSegChange}
        style={{ color: '#255353ff', width: '50%', padding: "6px" }}
      />

      <div style={{ marginTop: 20 }}>
        {selectedTab === "All T&C" ? (
          <ListALLTC onEdit={handleEdit} />
        ) : (
          <TandC
            initialData={editData}
            handleHomeSeg={handleHomeSeg} />
        )}
      </div>
    </div>
  );
};

export default ManageTC;
